import TagManager from 'react-gtm-module';

export const pushData = data => {
  TagManager.dataLayer({
    dataLayer: data,
  });
};

export const pushGAAction = (eventCategory, eventAction, eventLabel, data) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'nitroevent',
      gtaaction: {
        category: eventCategory || '',
        action: eventAction || '',
        label: eventLabel || '',
      },
      actiondata: data,
    },
  });
};



// WEBPACK FOOTER //
// ./src/utils/gtm.js